import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import MDCircularProgress from "components/MDCircularProgress";

const LoadWrapper = styled(Box)(({ theme }) => ({
  top: 0,
  left: 0,
  width: "100%",
  height: "100vh",
  display: "flex",
  position: "fixed",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1100,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  // backgroundColor: theme.palette.darkblue.hover,
}));

function MDLoader() {
  return (
    <LoadWrapper data-testid="main_Whole_page_loader">
      <MDCircularProgress
        size={150}
        color="info"
        sx={{
          position: "absolute",
        }}
      />
    </LoadWrapper>
  );
}

export default MDLoader;
